import { Button } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonContainer, ContentContainer, StyledTypography } from './ui';

export type UploadContentProps = {
    companyName: string;
    onDownloadClick: () => void;
};

const UploadContent = ({ companyName, onDownloadClick }: UploadContentProps) => {
    const { t } = useTranslation('importExportExcel');

    const handleDownloadTemplate = useCallback(
        e => {
            e.preventDefault();
            onDownloadClick();
        },
        [onDownloadClick]
    );

    return (
        <ContentContainer direction="vertical">
            <StyledTypography>{t('importExportExcel:description.message')}</StyledTypography>
            <StyledTypography>{t('importExportExcel:description.note')}</StyledTypography>
            {companyName !== 'BMW' && (
                <ButtonContainer direction="horizontal">
                    <Button onClick={handleDownloadTemplate} type="primary">
                        {t('importExportExcel:description.downloadTemplate')}
                    </Button>
                </ButtonContainer>
            )}
        </ContentContainer>
    );
};

export default UploadContent;
